/**
 * Shows or hides the top link if the y scroll position reaches the threshold.
 *
 * <a href="#start" class="top-link" title="Zum Seitenanfang">
 *    ...
 * </a>
 */
   window.addEventListener("DOMContentLoaded", () => {
   const topLink = document.querySelector(".top-link");
   const threshold = window.innerHeight;

   if (topLink) {
      window.addEventListener("scroll", () => {
         if (topLink) {
            if (window.scrollY > threshold) {
               topLink.classList.add("is-visible");
            } else {
               topLink.classList.remove("is-visible");
            }
         }
      });
   }
});
